export default function createCellUrl({
  useClientUrl = false,
  url = '',
} = {}) {
  return {
    componentName: 'cell-url',
    componentArgs: {
      useClientUrl,
      url,
    },
  };
}
